export default __webpack_public_path__ + "media/images/react_icons/copy_icon_dark-e2155fb470967c10d02debb73918e60f.svg";